<script setup lang="ts">
  import { ref, watch } from 'vue'
  import QRCode from 'qrcode'
  import { FormFieldContainer, InputField, UiButton } from '@logistiek-zonder-papier/lzp-library'

  const code = defineModel<string>()
  const emit = defineEmits(['submit'])
  const props = defineProps<{
    isSubmitting: boolean
    errorMessage: string | undefined
    setupUri: string | undefined
  }>()

  const qrDataUrl = ref<string | null>(null)

  async function generateQrCode() {
    if (!props.setupUri) return
    qrDataUrl.value = await QRCode.toDataURL(props.setupUri, {
      errorCorrectionLevel: 'H',
      margin: 1,
      width: 200,
    })
  }

  watch(
    () => props.setupUri,
    () => generateQrCode(),
    { immediate: true }
  )
</script>

<template>
  <div v-if="qrDataUrl" class="qr-code">
    <img :src="qrDataUrl" alt="Authenticator App Configuratie URI" />
    <h4>
      Scan de QR-code met uw authenticator app en voer de 6-cijferige code in om veilig in te
      loggen.
    </h4>
  </div>
  <FormFieldContainer label="Authenticator Code" :error="props.errorMessage">
    <InputField
      v-model="code"
      :error="!!props.errorMessage"
      type="text"
      autofocus
      placeholder="Voer de code van uw authenticator app in"
      required
      @keyup.enter="emit('submit')"
    />
  </FormFieldContainer>
  <UiButton
    :disabled="props.isSubmitting"
    label="Verzenden"
    type="submit"
    variant="prominent"
    @click="emit('submit')"
  />
</template>

<style scoped>
  .qr-code {
    text-align: center;
  }

  img {
    margin-bottom: var(--spacing-m);
  }

  .error {
    color: var(--colours-support-negative);
  }
</style>
